'use strict';

const $ = require('jquery');
const template = require('lodash/template');

const html = require('html-loader!./castCreative.html');

const SELECTORS = {
    LINKS: '.crew-list__item-link',
    CONTAINER: '.global-container',
    CLOSE: '.cast-overlay__close-button',
    INNER: '.cast-overlay__inner',
};

const CLASSES = {
    OVERLAY_OPEN: 'is-toggled',
};

let compiled = null;
let overlay = null;

function init() {
    const links = $(SELECTORS.LINKS);

    if (!links.length) {
        return false;
    }

    compiled = template(html);

    links.each(function () {
        $(this).on('click', fetchDetails);
    });
}

function fetchDetails(event) {
    event.preventDefault();

    const href = $(this).attr('href');

    $.ajax({ url: href, dataType: 'json' })
        .done(displayProfile)
        .fail(function () {
            // do nothing!
        });
}

function displayProfile(response) {
    let content = null;
    let more = [];

    $(response.content).each(function () {
        const $this = $(this);

        if (!$this.get(0).tagName) {
            return true;
        }

        const html = $this.wrap('<div/>').parent().html();

        if (!content) {
            return (content = html);
        }

        more.push(html);
    });

    if (more.length) {
        more = more.join('');
    } else {
        more = null;
    }

    response.content = content;
    response.more = more;

    overlay = $(compiled(response));

    overlay.find(SELECTORS.CLOSE).on('click', closeProfile);

    // overlay.on('click', function (e) {
    //     if ($(e.target).parents(SELECTORS.INNER).length) {
    //         return true;
    //     }

    //     closeProfile();
    // });

    $.when(
        $('body').append(overlay)
    ).then(function () {
        overlay.addClass(CLASSES.OVERLAY_OPEN);
    });
}

function closeProfile() {
    overlay.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
        overlay.empty().remove();
        overlay = null;
    });

    overlay.removeClass(CLASSES.OVERLAY_OPEN)
}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./modules/castCreative.js